import apiBase from "../../api/axios";

export const getFrasesService = async (page = 1, search = "", talento = "", isRandom = "") => {
  let url = `v1/talentos-global/frases/?page=${page}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  if (talento) {
    url += `&talento=${talento}`;
  }
  if (isRandom !== "") {
    url += `&is_random=${isRandom}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};

export const createFraseService = async (payload) => {
  const response = await apiBase.post("v1/talentos-global/frases/", payload);
  return response.data;
};

export const getFraseByIdService = async (id) => {
  const response = await apiBase.get(`v1/talentos-global/frases/${id}/`);
  return response.data;
};

export const updateFraseService = async (id, payload) => {
  const response = await apiBase.put(`v1/talentos-global/frases/${id}/`, payload);
  return response.data;
};

export const toggleFraseActiveService = async (id) => {
  const response = await apiBase.patch(`v1/talentos-global/frases/${id}/toggle-status/`);
  return response.data;
};

export const getTalentosSelectoresService = async (search = "") => {
  let url = "v1/talentos-global/selectores/talentos/";
  if (search) {
    url += `?search=${encodeURIComponent(search)}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};
